import React from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  ButtonGroup,
  Button,
  Spinner,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';

const PatientValuesCard = (props: {
  viewPath?: string;
  editPath?: string;
  newPath?: string;
  created?: string;
  loading?: boolean;
  disabled?: boolean;
}) => (
  <Card>
    <CardBody>
      <CardTitle>Patient Values</CardTitle>
      <Table borderless>
        <thead>
          <tr>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {props.created ? moment(props.created).format('DD-MM-YYYY') : '-'}
            </td>
            <td>
              <ButtonGroup style={{ width: '100%' }}>
                {!props.loading ? (
                  !!props.editPath ? (
                    <>
                      <Button
                        tag={Link}
                        color="warning"
                        to={props.editPath}
                        disabled={props.disabled}>
                        Edit
                      </Button>
                      <Button
                        tag={Link}
                        color="success"
                        to={props.viewPath}
                        disabled={props.disabled}>
                        View
                      </Button>
                    </>
                  ) : props.newPath ? (
                    <Button
                      tag={Link}
                      color="primary"
                      to={props.newPath}
                      disabled={props.disabled}
                      block>
                      New
                    </Button>
                  ) : null
                ) : (
                  <Spinner></Spinner>
                )}
              </ButtonGroup>
            </td>
          </tr>
        </tbody>
      </Table>
    </CardBody>
  </Card>
);

export default PatientValuesCard;
